export class AzureRestorePointDisk {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "lun",
            "baseName": "lun",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "isOsDisk",
            "baseName": "isOsDisk",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sizeGb",
            "baseName": "sizeGb",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "sku",
            "baseName": "sku",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureRestorePointDisk.attributeTypeMap;
    }
    constructor() {
    }
}
